import { createLinkMatcherWithRegExp } from '@lexical/react/LexicalAutoLinkPlugin';
const supportsLookbehind = (() => {
    try {
        new RegExp('(?<![-.+():%])');
        return true;
    }
    catch {
        return false;
    }
})();
// These are the recommended regular expressions from the Lexical Playground Auto Link Plugin.
// Safari before 16.4 does not support lookbehind, so use a compatible fallback there.
const URL_REGEX = supportsLookbehind
    ? /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)(?<![-.+():%])/
    : /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
const EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
export const URL_MATCHER = createLinkMatcherWithRegExp(URL_REGEX, (text) => text.startsWith('http') ? text : `https://${text}`);
export const EMAIL_MATCHER = createLinkMatcherWithRegExp(EMAIL_REGEX, (text) => `mailto:${text}`);
//# sourceMappingURL=matchers.js.map